import { Switch, SwitchProps } from "@mui/material";
import React, { ChangeEvent } from "react";
import Flex from "./Flex";
import Text from "./Text";

type FormSwitchProps = {
  checked: boolean;
  switchVisible?: boolean;
  readOnly?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  customLabels?: typeof DEFAULT_CUSTOM_LABELS;
} & SwitchProps;

/**
 * this custom component is design specially for form switches
 * @returns plain component of toggle Switch
 *
 * @author rajkumar rathod
 */
const FormSwitch: React.FC<FormSwitchProps> = ({
  checked,
  switchVisible = true,
  readOnly = false,
  onChange,
  customLabels = DEFAULT_CUSTOM_LABELS,
  ...others
}) => {
  function getBgColorWhileNonSelectable(): string {
    if (switchVisible) return "#1A1A1A0F";
    else return checked ? "#54913526" : "#FF000026";
  }

  function getColorWhileNonSelectable(): string | undefined {
    if (switchVisible) return;
    else return checked ? "#549135" : "#FF3300";
  }

  return (
    <Flex
      borderRadius={2}
      justifyContent={"space-evenly"}
      alignItems={"center"}
      bgcolor={getBgColorWhileNonSelectable()}
      color={getColorWhileNonSelectable()}
      padding={"6px"}
      minWidth={"110px"}
      textAlign={"center"}
      gap={1}
    >
      {switchVisible && (
        <Switch
          {...others}
          checked={checked}
          disabled={readOnly}
          onChange={onChange}
          size="small"
        />
      )}
      <Text>
        {checked ? customLabels.true.label : customLabels.false.label}
      </Text>
    </Flex>
  );
};

export default FormSwitch;

const DEFAULT_CUSTOM_LABELS = {
  true: {
    label: "Active",
  },
  false: {
    label: "Inactive",
  },
};
